import React from 'react';
import MortgageQuestionnare from './MortgageQuestionnaire.js';

var MortgageQuestionnareBlock = {
  Component: function Component(_ref) {
    var attrs = _ref.attrs;
    var _attrs$pathName = attrs.pathName,
      pathName = _attrs$pathName === void 0 ? '/mortgage-rates/' : _attrs$pathName,
      _attrs$landingPage = attrs.landingPage,
      landingPage = _attrs$landingPage === void 0 ? 'mortgage-rates' : _attrs$landingPage;
    return /*#__PURE__*/React.createElement(MortgageQuestionnare, {
      pathName: pathName,
      landingPage: landingPage
    });
  },
  metadata: {
    version: '1.0',
    name: 'constellation/mortgage-questionnaire',
    title: 'Mortgage Questionnare',
    description: "Compare today's mortgage rates and get a customized quote from a lender that fits your needs.",
    icon: 'businessperson',
    keywords: ['mortgages', 'quizes'],
    supports: {
      customClassName: false,
      html: false
    },
    category: 'Information',
    attributes: {
      pathName: {
        type: 'string',
        label: 'Default pathname',
        default: '/mortgage-rates/',
        control: 'text'
      },
      landingPage: {
        //When accessing refinance page then landingPage value will be refinance
        type: 'string',
        label: 'Default landing page',
        default: 'mortgage-rates',
        control: 'text'
      }
    }
  }
};
var MortgageQuestionnareBlock$1 = MortgageQuestionnareBlock;

export { MortgageQuestionnareBlock$1 as default };
